exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-state[data-v-1fec4fe6]{min-width:1rem;max-width:100%;display:inline-flex;border-radius:.25rem;background-color:var(--fts-gray-5);cursor:default}.fts-state>div[data-v-1fec4fe6]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:.275rem .475rem;line-height:normal;color:#fff;font-size:.75rem;font-weight:700;cursor:inherit}.fts-state.fts-state-md>div[data-v-1fec4fe6]{font-size:1rem}", ""]);

// exports
